import React from "react";
import Slider from "react-slick";

import TitleSection from "../title-section";
import { ReferenciaMultimedia } from "../../../interfaces/ReferenciaMultimedia";

// Styles //
import "slick-carousel/slick/slick.css";
import "./JobTipsCarousel.scss";
import MediaCard from "../media-card/mediaCard";

const MAIN_CLASS = "m-job-tips-carousel";

interface JobTipsPostsCarouselProps {
    posts: {
        slug: string;
        postData: ReferenciaMultimedia;
    }[];
}

const SLIDES_TO_SCROLL = 1;

const JobTipsPostsCarousel = ({ posts }: JobTipsPostsCarouselProps) => {
    const isBrowser = typeof window !== "undefined";

    const urlOrigin = isBrowser ? window.location.origin : "";

    const CarouselGeneral = {
        arrows: false,
        slidesToScroll: SLIDES_TO_SCROLL,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: SLIDES_TO_SCROLL,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: SLIDES_TO_SCROLL,
                    variableWidth: true,
                },
            },
        ],
    };

    if (!posts || !posts.length) return null;

    return (
        <div className={MAIN_CLASS}>
            <div className={`${MAIN_CLASS}__wrapper`}>
                <div className={`${MAIN_CLASS}__title-container`}>
                    <TitleSection
                        title="Consejos y tips para conseguir empleo"
                        type="h3"
                    />
                </div>

                <div className={`${MAIN_CLASS}__slider`}>
                    <Slider {...CarouselGeneral}>
                        {posts?.map((post, postIdx) => {
                            const { postData: item } = post as any;
                            return (
                                <div key={`post-${post.slug}-${postIdx}`}>
                                    <MediaCard
                                        tituloMultimedia={item.tituloMultimedia}
                                        descripcion={item.descripcion}
                                        imagenPrincipal={item.imagenPrincipal}
                                        tituloBoton={"Ver más"}
                                        tematica={item.tematica}
                                        categoriaMultimedia={
                                            item.categoriaMultimedia
                                        }
                                        nuevoContenido={false}
                                        textoIntroductorio={
                                            item.textoIntroductorio
                                        }
                                        slug={`${urlOrigin}/servicio-de-empleo/personas/biblioteca/${item.parentSlug}${item.slug}`}
                                        parentContentfulId={
                                            item.parentContentfulId
                                        }
                                        createdAt={item.createdAt}
                                        tituloEvento={""}
                                        tipoEvento={""}
                                        modoEvento={""}
                                        fechaEvento={""}
                                        horaEvento={""}
                                        lugarEvento={""}
                                        disclaimer={""}
                                        onClickShare={() => undefined}
                                        setLinkUrl={() => undefined}
                                    />
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default JobTipsPostsCarousel;
